import Profile from './Profile';
import { UserIsAuthenticated, siteTitle } from '../';

const ProfileRoutes = {
    profile: {
        path: '/Profile/',
        label: 'Profile',
        title: `${siteTitle} - Profile`,
        component: UserIsAuthenticated(Profile)
    }
};

export { ProfileRoutes, Profile };



// WEBPACK FOOTER //
// ./src/app/containers/Profile/index.ts